import React, { useEffect, useCallback, memo } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import connectOptions, { mergeProps } from '../../utils/connectOptions';
import Popups from '../../components/Popup';
import * as TARGET from '../../actions/findEmail';
import { unwrap } from '../../utils/ChangeSpy';
import { PrettyErrorProvider } from '../../contexts/PrettyErrorContext';
import { usePopupContext } from '../../contexts/PopupContext';

const EmailFinderPopupContainer = ({
  finder,
  children,
  isValid,
  inputErrors,
  popup,
  findEmail,
  clearFoundEmail,
  closeValidationError,
  handleUpdateFinder,
}) => {
  const context = usePopupContext();

  useEffect(
    () => () => {
      clearFoundEmail();
    },
    [clearFoundEmail],
  );

  useEffect(() => {
    if (context.hasPopup()) {
      context.onClosePopup(() => {
        const popupName = popup.getIn(['props', 'reopenPopupName']);
        const popupProps = popup.getIn(['props']);

        context.openPopup(popupName, popupProps);
      });
    }
  }, [popup]);

  const handleErrorClose = useCallback(
    (event, field) => {
      closeValidationError({ field });
    },
    [closeValidationError],
  );

  const handleChange = useCallback(
    event => {
      const { name, value } = event.target;

      return handleUpdateFinder({ name, value });
    },
    [handleUpdateFinder],
  );

  const handleFind = useCallback(() => {
    if (isValid) {
      findEmail({
        fullName: unwrap(finder.get('fullName')),
        domain: unwrap(finder.get('domain')),
      });
    }
  }, [isValid, finder, findEmail]);

  return (
    <PrettyErrorProvider inputErrors={inputErrors} onErrorClose={handleErrorClose}>
      <>
        <Popups.EmailFinderPopup finder={finder} isValid={isValid} onChange={handleChange} onFind={handleFind} />
        {children}
      </>
    </PrettyErrorProvider>
  );
};

function mapStateToProps(state) {
  return {
    isValid: state.findEmail.get('isValid', false),
    inputErrors: state.findEmail.get('inputErrors'),
    finder: state.findEmail,
  };
}

function mapDispatchToProps(dispatch) {
  const { findEmail, clearFoundEmail, closeValidationError, handleUpdateFinder } = TARGET;

  return bindActionCreators(
    {
      findEmail,
      clearFoundEmail,
      closeValidationError,
      handleUpdateFinder,
    },
    dispatch,
  );
}

export { EmailFinderPopupContainer };

const Connected = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
  connectOptions,
)(memo(EmailFinderPopupContainer));

export default Connected;
